<template>
  <div></div>
</template>

<script>
export default {
  name: 'IndexPage',
  props: [],
  components: {
  },
  data: function () {
    return {
    };
  },
  computed: {
  },
  methods: {
  },
  mounted() {
    if (this.$store.state.client.authenticated) {
      this.$router.push({ name: 'files' });
    } else {
      this.$router.push({ name: 'landing' });
    }
  },
}
</script>

<style scoped>
</style>
